module.exports = __webpack_public_path__ + "img/second_redhua.56f96e23.png";